var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgJobsHeroLifeline = function SvgJobsHeroLifeline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1071,
    height: 354,
    fill: "none",
    preserveAspectRatio: "none",
    viewBox: "0 0 1071 354"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#EF737A",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M653.702 42.5C755.489 17.948 867.587-23.863 970.23 20.52c97.21 41.97 131.25 155.308 63.02 238.521-108.378 132.16-319.686 99.416-461.317 54.836-115.415-36.328-227.405-87.048-347.232-103.672-34.243-4.759-68.968-6.69-102.705-14.301C66.288 183.328 5.363 148.081 1.249 84.622-1.6 40.707 20.003 9.507 64.45 15.945c46.377 6.714 89.124 33.936 135.11 43.938C267.677 74.69 341.15 76.069 410.555 74.345c81.861-2.046 163.515-12.669 243.147-31.867z"
  })));
};
export default SvgJobsHeroLifeline;